<template>
    <div class="row">
        <div class="col-md-12">
            <h4 style="margin-top:40px" class="master-template__form--field-set">INTEREST</h4>
        </div>
        <div class="col-md-12">
            <div style="margin-bottom:16px" id="type_of_metal_color-form-group" class="alt-form-group select-form-group form-group is_required"
                data-id="type_of_metal_color"><label style="margin-bottom: 5px;" for="type_of_metal_color">Which jewellery type do you prefer?
                </label>
                <div class="alt-form-field-group"><input type="text" id="type_of_metal_color" name="type_of_metal_color"
                        class="form-control" value="" style="position: absolute;height: 0;top: 10px;opacity: 0;">
                    <div class="master-template__select-option custom_option_pt" id="group-type_of_metal_color">
                        <div class="pt_option_select"><button type="button" class="gender-button active"
                                data-value="Yellow Gold" data-group="type_of_metal_color" fdprocessedid="y86cgu">Yellow
                                Gold</button><button type="button" class="gender-button " data-value="Diamond"
                                data-group="type_of_metal_color" fdprocessedid="6agmuh">Diamond</button></div>
                    </div>
                    <input type="hidden" name="type_of_metal_color" class="custom_type_of_metal_color"
                        id="type_of_metal_color" value="Diamond">
                </div>
            </div>
            <div style="margin-bottom:16px" id="type_of_jewellery-form-group" class="alt-form-group select-form-group form-group is_required"
                data-id="type_of_jewellery"><label  style="margin-bottom: 5px;" for="type_of_jewellery">Have you shopped with SK Jewellery before?
                </label>
                <div class="alt-form-field-group"><input type="text" id="type_of_jewellery" name="type_of_jewellery"
                        class="form-control" value="" style="position: absolute;height: 0;top: 10px;opacity: 0;">
                    <div class="master-template__select-option custom_option_pt" id="group-type_of_jewellery">
                        <div class="pt_option_select"><button type="button" class="gender-button active"
                                data-value="Yes" data-group="type_of_jewellery"
                                fdprocessedid="3162t">Yes</button><button type="button" class="gender-button "
                                data-value="No" data-group="type_of_jewellery" fdprocessedid="uq4hvs">No</button></div>
                    </div>
                    <input type="hidden" name="type_of_jewellery" class="custom_type_of_jewellery"
                        id="type_of_jewellery" value="Yes">
                </div>
            </div>
        </div>

    </div>
</template>
<script setup>
const props = defineProps({
    options: Object
})
onMounted(() => {
    nextTick(() => {
        document.querySelectorAll("#group-type_of_metal_color .gender-button").forEach(function (button) {
            button.addEventListener("click", function () {
                document.querySelectorAll("#group-type_of_metal_color .gender-button").forEach(function (btn) {
                    btn.classList.remove("active");
                });

                this.classList.add("active");

                document.querySelector(".custom_type_of_metal_color").value = this.getAttribute("data-value");
            });
        });
        document.querySelectorAll("#group-type_of_jewellery .gender-button").forEach(function (button) {
            button.addEventListener("click", function () {
                document.querySelectorAll("#group-type_of_jewellery .gender-button").forEach(function (btn) {
                    btn.classList.remove("active");
                });

                this.classList.add("active");

                document.querySelector(".custom_type_of_jewellery").value = this.getAttribute("data-value");
            });
        });

    })
})


</script>
<style lang="scss">
.master-template__select-option.custom_option_pt .pt_option_select {
    display: flex;
    gap: 15px;
    background: #c60c46;
    width: max-content;
    padding: 8px;
    height: 40px;
    border-radius: 5px;
}

.master-template__select-option.custom_option_pt .pt_option_select button {
    background: transparent;
    border: none;
    padding: 1px 20px;
    color: #FFFFFF;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
}

.master-template__select-option.custom_option_pt .pt_option_select button.active {
    background: #ffffff;
    color: #000000;
}

.social-account-options.pt_custom_checkbox {
    text-align: left;
}

.social-account-options.pt_custom_checkbox label {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
}
</style>